import CustomizedDialog from './CustomizedDialog';

export default CustomizedDialog;
